import mutations from './occupationHealthLabReport.mutations'
import actions from './occupationHealthLabReport.actions'
import getters from './occupationHealthLabReport.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
